/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import {
  FullProvenanceProps,
  TOSProductProps,
  FeedbackFormProps,
  getOCRFullProvenanceProps,
} from "./components";

const is = require("is_js");

const SERVICE_NAME = "FullProvenancePageService";
const log: any = LoggerModule.getInstance();

export class FullProvenancePageService {
  private static instance: FullProvenancePageService;
  private vapp: VApplication;
  private fullProvenanceRestAPI: string;
  private getTemplateRestAPI: string;
  public ageConfirm: boolean = false;
  public ocrProvenanceData: any;
  public locationData: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.fullProvenanceRestAPI = props?.fullProvenanceRestAPI;
    this.getTemplateRestAPI = props?.getTemplateRestAPI;
    //this.headers = props?.headers;
  }

  public static getInstance(props: any = {}): FullProvenancePageService {
    if (!FullProvenancePageService.instance) {
      FullProvenancePageService.instance = new FullProvenancePageService(props);
    }
    return FullProvenancePageService.instance;
  }

  //private instances
  private setAgeConfirm(isAgeConfirmed: boolean) {
    this.ageConfirm = isAgeConfirmed;
  }

  public setOcrFullProvenanceData(data: any) {
    console.log(` in setOcrFullProvenanceData service :`, data);
    this.ocrProvenanceData = data;
  }

  public setLocationData(data: any) {
    console.log(`set location data : `, data)
    this.locationData = data;
  }

  //------------------------------------

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    console.log(`agent bla:`, agent)

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getFullProvenance() {
    console.log(` in index of service :`);
    let _args = {
      apiURL: this.fullProvenanceRestAPI,
      templateAPIURL: this.getTemplateRestAPI,
      //headers: this.headers
    };
    const agent = getAgent();
    return agent.getFullProvenance(_args);
  }

  public async tosProduct(args: TOSProductProps) {
    console.log(` in index of service :`);
    this.setAgeConfirm(args?.isAgeConfirmed);
    let _args = {
      ...args,
      apiURL: this.fullProvenanceRestAPI,

      //headers: this.headers
    };
    const agent = getAgent();
    return agent.tosProduct(_args);
  }

  public async feedbackForm(args: FeedbackFormProps) {
    console.log(` in index of feedbackForm service :`);
    let _args = {
      ...args,
      apiURL: this.fullProvenanceRestAPI,
    };
    const agent = getAgent();
    return agent.feedbackForm(_args);
  }

  public async getOCRFullProvenance(args: getOCRFullProvenanceProps) {
    let _args = {
      ...args,
      apiURL: this.fullProvenanceRestAPI,
      templateAPIURL: this.getTemplateRestAPI,
      latitude: this.locationData?.latitude,
      longitude: this.locationData?.longitude,
    };
    const agent = getAgent();
    return  agent.getOCRFullProvenance(_args);
  }
}